<div [formGroup]="form" class="step-form">

  <mat-form-field appearance="outline" class="step-field-full">
    <mat-label>Template Name</mat-label>
    <mat-icon matPrefix>label</mat-icon>
    <input matInput formControlName="templateName" autocomplete="off"
           placeholder="Enter a unique template name" />
    <mat-hint *ngIf="form.get('templateName')?.pending">Checking availability…</mat-hint>
    <mat-hint *ngIf="!form.get('templateName')?.pending">Must be globally unique — letters, numbers, hyphens, underscores and dots only</mat-hint>
    <mat-error *ngIf="form.get('templateName')?.hasError('required')">
      Template name is required
    </mat-error>
    <mat-error *ngIf="form.get('templateName')?.hasError('pattern')">
      Only letters, numbers, hyphens ( - ), underscores ( _ ) and dots ( . ) are allowed
    </mat-error>
    <mat-error *ngIf="form.get('templateName')?.hasError('nameTaken')">
      This template name is already in use
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="step-field-full">
    <mat-label>Description (optional)</mat-label>
    <mat-icon matPrefix>description</mat-icon>
    <textarea matInput formControlName="templateDescription" rows="3"
              placeholder="Describe this template's purpose and intended use…"></textarea>

  </mat-form-field>

</div>
